export default function FAQSection() {
  const faqs = [
    {
      q: '什么是火影忍者同人创作？',
      a: '火影忍者同人创作是指基于《火影忍者》原作世界观、角色、剧情等元素进行的二次创作。包括同人小说、同人插画、同人漫画、CP配对创作等多种形式。创作者在尊重原著的基础上，发挥想象力和创造力，创作出全新的故事和作品。',
    },
    {
      q: '新手如何开始火影同人创作？',
      a: '新手建议从短篇同人小说或简单角色插画开始。首先要充分理解火影忍者的世界观和角色性格，然后选择一个感兴趣的创作方向。可以从模仿经典场景练习开始，逐步发展出个人的创作风格。本站的"创作教程"分类有完整的入门指南。',
    },
    {
      q: '火影同人创作有哪些热门方向？',
      a: '目前最热门的火影同人创作方向包括：鸣佐CP同人、平行世界/IF线剧情、角色重塑（如小樱实力增强向）、晓组织视角的故事、穿越/重生题材等。此外，同人插画和漫画也是受众广泛的创作形式。',
    },
    {
      q: '同人创作需要注意哪些版权问题？',
      a: '同人创作属于二次创作范畴。创作者应注意：标注原作版权归属、声明为非商业性创作（如有商业用途需获得授权）、尊重原作基础设定不过度扭曲角色。在日本，同人创作一般受到相对宽松的对待，但仍需遵守相关法律法规。',
    },
    {
      q: '如何提高同人作品的质量和人气？',
      a: '提高作品质量需要持续练习和积累：多看优秀的同人作品学习技巧、重视角色性格的准确性、注重文笔/画工的提升。提高人气方面，选择合适的发布平台、优化标题和标签、积极参与社区互动、保持稳定的更新频率都是有效的方法。',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-3">
              常见问题
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              关于火影忍者同人创作，你可能会关心这些问题
            </p>
          </div>
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <details
                key={index}
                className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
              >
                <summary className="flex items-center justify-between px-6 py-4 cursor-pointer list-none">
                  <h4 className="font-heading text-base font-semibold text-foreground-900 pr-8">
                    {faq.q}
                  </h4>
                  <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-500 group-open:rotate-180 transition-transform duration-200">
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </span>
                </summary>
                <div className="px-6 pb-5">
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}